import React, { useState } from 'react';
import { IonIcon, IonLabel } from '@ionic/react';
import { checkmarkOutline, copyOutline } from 'ionicons/icons';
import styles from './CopyableIdTitle.module.scss';

interface CopyableIdTitleProps {
  title: string;
  /** The ID to reveal. Without one the title is plain text (nothing to tap). */
  id?: string | null;
}

/**
 * Modal header title that reveals a small ID line when tapped; tapping the ID
 * copies it. Render it inside the header's IonTitle (or BasePageWithHeader's
 * titleNode) — the parent supplies the title typography.
 */
const CopyableIdTitle: React.FC<CopyableIdTitleProps> = ({ title, id }) => {
  const [revealed, setRevealed] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!id) return;
    navigator.clipboard.writeText(id).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => { /* clipboard unavailable — nothing to do */ });
  };

  return (
    <IonLabel className={styles.stack}>
      <span
        className={id ? styles.clickable : undefined}
        onClick={() => { if (id) setRevealed((v) => !v); }}
      >{title}</span>
      {revealed && id && (
        <span className={styles.idRow} onClick={handleCopy}>
          <span className={styles.idText}>#{id}</span>
          <IonIcon className={styles.copyIcon} icon={copied ? checkmarkOutline : copyOutline} />
        </span>
      )}
    </IonLabel>
  );
};

export default CopyableIdTitle;
